module.exports = __webpack_public_path__ + "static/media/4.7d83e7a7.png";